import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API, PostItem, PostType, WpPostItem } from '@apps/api-interfaces';
import { environment } from '../../../environments/environment';
import { getCookie } from '@apps/tools';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class PostsService {
  constructor(private http: HttpClient) {}

  async getPosts(type?: PostType): Promise<PostItem[]> {
    const url = API.POSTS;
    const params = type ? { type } : {};
    const headers = {};
    if (getCookie('cid')) {
      headers['cid'] = getCookie('cid');
    }
    return await this.http
      .get<PostItem[]>(url, {
        headers,
        params
      })
      .toPromise();
  }

  async getPost(slug: string): Promise<PostItem> {
    const url = `${API.POSTS}/slug/${slug}`;
    return await this.http.get<PostItem>(url).toPromise();
  }

  // Aktualnosci z zl-backend (nowy portal). Wolane wylacznie w przegladarce
  // (effect ma guard SSR) - newsy nie sa prerenderowane.
  async getNews(limit = 6): Promise<WpPostItem[]> {
    const base = environment.contentApiUrl || '/zl-api';
    const url = `${base}/content/aktualnosci`;

    return await this.http
      .get<WpPostItem[]>(url, { params: { limit: `${limit}` } })
      .pipe(
        map(items =>
          (items || []).map(item => ({
            ...item,
            link: (item as any).url || item.link
          }))
        ),
        catchError(() => of([]))
      )
      .toPromise();
  }

}
